import { isValidPhoneNumber } from 'libphonenumber-js';

/* eslint-disable security/detect-unsafe-regex */
const POSTAL_CODE_PATTERN = /^[0-9]{5}(?:-[0-9]{4})?$/;
const EMAIL_PATTERN = /^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,63})+$/;
/* eslint-enable security/detect-unsafe-regex */

export const validateValue = (type, value, options = {}) => {
  switch (type) {
    case 'required':
      return value !== undefined && !(Array.isArray(value) && value.length === 0);
    case 'between':
      return value >= options.min && value <= options.max;
    case 'postalCode':
      return POSTAL_CODE_PATTERN.test(value);
    case 'emailAddress':
    case 'email':
      return EMAIL_PATTERN.test(value);
    case 'phoneNumber':
      return !value || isValidPhoneNumber(value, 'US') === true;
    default:
      return true;
  }
};

export const getFormInputValidationsOptions = (props) => {
  const result = {};
  if(props?.required) result['required'] = true;
  if(props?.max && props.max > 0) result['max'] = props.max;
  if(props?.min && props.min > 0) result['min'] = props.min;
  if(props?.maxLength && props.maxLength > 0) result['maxLength'] = props.maxLength;
  if(props?.minLength && props.minLength > 0) result['minLength'] = props.minLength;
  if(props?.matchPattern) result['pattern'] = props.matchPattern;
  if(props?.isEmail) result['pattern'] = EMAIL_PATTERN;
  if(props?.isPhoneNumber) result['validate'] = v => validateValue('phoneNumber', v);
  return result;
};